import { Link } from 'react-router-dom';
import { Heading } from '../../../ui/components/Heading/Heading';
import { Icon } from '../../../ui/components/Icon/Icon';
import styles from './OtherServices.module.scss';

export interface ArticleCard {
  img: string;
  title: string;
  to?: string;
}

interface OtherServicesProps {
  title: string;
  articleCards: ArticleCard[];
}

export const OtherServices = ({ title, articleCards }: OtherServicesProps) => {
  const renderArticles = () => {
    return articleCards.map((article) => (
      <li className={styles.article} key={`${article.title}-${article.img}`}>
        <Link className={styles.link} to={article.to || '/wellness-notes'}>
          <span className={styles.image}>
            <img loading="lazy" src={article.img} alt={article.title} />
          </span>
          <span className={styles.copy}>
            <Heading className={styles['article-title']} headingLevel="h3">
              {article.title}
            </Heading>
            <span className={styles.action}>
              Read note
              <Icon type="right-arrow" alt="Read note" />
            </span>
          </span>
        </Link>
      </li>
    ));
  };
  return (
    <div className={styles.root}>
      <Heading
        className={styles.title}
        headingDecoration="under"
        headingLevel="h2"
      >
        {title}
      </Heading>
      <ul className={styles.articles}>{renderArticles()}</ul>
    </div>
  );
};
